function accordion() {
  document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('details');

    // Check if at least one accordion exists
    if (accordions.length > 0) {
      accordions.forEach((accordion) => {
        const expandIcon = accordion.querySelector('.expand-icon');
        // Initialize correct symbol for open sections
        if (accordion.open) {
          expandIcon.dataset.state = 'expanded';
        } else {
          expandIcon.dataset.state = 'collapsed';
        }
        accordion.addEventListener('toggle', () => {
          // Toggle icon based on open state
          const isOpen = accordion.open;
          expandIcon.dataset.state = isOpen ? 'expanded' : 'collapsed';
        });
      });
    }
  });  
}

export { accordion };